export const HERO_NAVBAR_HEIGHT: string = '48px';
